import React from 'react';
import Moment from 'react-moment';
import { Link } from 'react-router-dom';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Username from "../common/Username";
import {readableApplicationState} from "../common/util";
import FlipMove from 'react-flip-move';

const ApplicationList = (props) => (
    <div>
        <FlipMove
            staggerDelayBy={100}
            appearAnimation="fade"
            enterAnimation="fade"
            leaveAnimation="fade"
        >
        { props.applications.map((application) => (
        <div className="panel-adt" key={`${application.id}-applications`}>
            <Row>
                <Col md={8}>
                    <Row>
                        <Col md={4}><Username user={props.users[application.user]} rank={null} /></Col>
                        <Col md={4}>
                            <span className="timestamp">
                                <OverlayTrigger placement="top" overlay={<Tooltip id="created-tooltip">Date Created</Tooltip>}>
                                    <Moment format="ddd MMM D YYYY">{application.created}</Moment>
                                </OverlayTrigger>
                            </span>
                        </Col>

                    </Row>
                    <Row>
                        <Col md={4}>{application.characterName} {application.characterLevel} {application.characterClass}</Col>
                        <Col md={4}>
                            <span className="timestamp">
                                <OverlayTrigger placement="top" overlay={<Tooltip id="created-tooltip">Last Updated</Tooltip>}>
                                    <Moment fromNow>{application.lastUpdated}</Moment>
                                </OverlayTrigger>
                            </span>
                        </Col>

                    </Row>
                </Col>
                <Col md={4}><Link to={props.location+application.id}><h3 className="pull-right">{readableApplicationState(application.state)}</h3></Link></Col>
            </Row>
        </div>
        ))}
        </FlipMove>
        {props.applications.length === 0 ? (
            <div className="panel-adt">
                No Applications
            </div>
        ) : ('')}
    </div>
);

export default ApplicationList;


// WEBPACK FOOTER //
// ./src/Applications/ApplicationList.js